import { lazy, Suspense } from 'react'

const InfoSchema = lazy(() => import('./landing/themes/info/schema'))
const MedSchema = lazy(() => import('./landing/themes/med/schema'))
const DreptSchema = lazy(() => import('./landing/themes/drept/schema'))
const ReziSchema = lazy(() => import('./landing/themes/rezi/schema'))

const schema = {
  info: <InfoSchema />,
  med: <MedSchema />,
  drept: <DreptSchema />,
  rezi: <ReziSchema />,
}

export const ColorSchema = ({ children }) => {
  return (
    <>
      <Suspense fallback={null}>{schema[process.env.REACT_APP_TYPE]}</Suspense>
      {children}
    </>
  )
}
